<template>
  <div v-masonry transition-duration="0.3s" item-selector=".groupe" class="container">
    <div v-for="groupe in groupes" :key="groupe.id" class="groupe" v-masonry-tile>
      <h3>{{groupe.nom}}</h3>
      <p v-if="groupe.nbr_musicien !== ''">{{ groupe.nbr_musicien }} musiciens</p>
      <ul>
        <li v-for="genre in groupe.genre" :key="genre.id">{{ genre }}</li>
      </ul>
      <h4>Contact</h4>
      <p class="pers">{{groupe.contact}}</p>
      <a v-if="groupe.mail !== ''" :href="'mailto:' + groupe.mail" class="mail">{{ groupe.mail }}</a>
      <a v-if="groupe.tel !== ''" :href="'tel:' + groupe.tel" class="tel">{{groupe.tel}}</a>
      <h4 v-if="groupe.link !== '' && groupe.website !== ''">Lien</h4>
      <a v-if="groupe.link !== ''" :href="groupe.link" class="link">{{groupe.link.split('/')[2]}}</a>
      <a v-if="groupe.website !== ''" :href="groupe.website" class="website">{{groupe.website.split('/')[2]}}</a>
      <div class="action">
        <button @click="storeGroupName(groupe.nom)" class="add">Ajouter</button>
        <button @click="update(groupe.nom)" class="update">Modifier</button>
        <button @click="destroy(groupe.nom)" class="delete">Supprimer</button>
      </div>
    </div>
    <div class="listes" v-if="onSelect">
      <ul>
        <li v-for="liste in listes" :key="liste.id" @click="add(selGroupName, liste.nom)">{{ liste.nom }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import {settings} from '../../assets/settings'

export default {
  name: 'Groupes',
  props: ['liste', 'listes', 'genre', 'token', 'search'],
  data () {
    return {
      groupes: [],
      selGroupName: '',
      onSelect: false
    }
  },
  watch: {
    token: function () {
      this.getGroups()
    },
    liste: function () {
      this.getGroups()
    },
    genre: function () {
      this.getGroups()
    },
    search: function () {
      this.getGroups()
    }
  },
  methods: {
    getGroups () {
      if (this.liste === '') {
        this.$http.get(settings.apiUrl + '/group/' + this.token).then((response) => {
          this.groupes = response.body.payload
          this.filtreGroups()
        })
      } else {
        this.$http.get(settings.apiUrl + '/list/' + this.liste + '/' + this.token).then((response) => {
          this.groupes = response.body.payload.groupe
          this.filtreGroups()
        })
      }
    },
    filtreGroups () {
      let temp = this.groupes
      if (this.genre !== '') {
        temp = temp.filter(groupe => groupe.genre.includes(this.genre))
      }
      if (this.search !== '') {
        temp = temp.filter(groupe => groupe.nom.toUpperCase().includes(this.search.toUpperCase()))
      }
      this.groupes = temp
    },
    add (groupName, listName) {
      let data = {
        groupe: groupName
      }
      this.$http.put(settings.apiUrl + '/list/' + listName + '/' + this.token, {data: JSON.stringify(data)}).then((response) => {
        if (!response.body.success) {
          alert('error')
        }
        this.getGroups()
      })
      this.onSelect = false
    },
    storeGroupName (groupName) {
      this.selGroupName = groupName
      this.onSelect = true
    },
    update (groupName) {
      window.location.replace('/#/updategroupe/' + groupName)
    },
    destroy (groupName) {
      if (this.liste !== '') {
        this.$http.delete(settings.apiUrl + '/list/' + this.liste + '/' + groupName + '/' + this.token).then((response) => {
          if (!response.body.success) {
            alert('error')
          }
          this.getGroups()
        })
      } else if (this.$admin === 1) {
        this.$http.delete(settings.apiUrl + '/group/' + groupName + '/' + this.token).then((response) => {
          if (!response.body.success) {
            alert('error')
          }
          this.getGroups()
        })
      } else {
        alert('vous n\'avez pas les droits pour faire cela.')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  margin: auto;
}
.groupe {
  background-color: #f4f4f4;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  width: 280px;
  margin: 20px;
  * {
    display: block;
  }
  h3 {
    padding: 10px;
    color: #fff;
    background-color: #175676;
  }
  h4 {
    padding: 5px 10px;
    color: #fff;
    background-color: #0E6998;
  }
  p {
    padding: 3px 10px;
  }
  ul {
    padding: 3px 10px;
    list-style-type: armenian;
  }
  a {
    padding: 3px 10px;
  }
  .action {
    padding: 20px 10px 10px 10px;
    display: flex;
    justify-content: space-around;
    button {
      padding: 10px;
      border: none;
      color: #fff;
      cursor: pointer;
    }
    .add {
      border: solid 2px #175676;
      background-color: #f4f4f4;
      color: #175676;
      border-radius: 4px;
      transition: all ease .3s;
    }
    .add:hover {
      background-color: #175676;
      color: #fff;
    }
    .update {
      border: solid 2px #44b787;
      background-color: #f4f4f4;
      color: #44b787;
      border-radius: 4px;
      transition: all ease .3s;
    }
    .update:hover {
      background-color: #44b787;
      color: #fff;
    }
    .delete {
      border: solid 2px #ba324f;
      background-color: #f4f4f4;
      color: #ba324f;
      border-radius: 4px;
      transition: all ease .3s;
    }
    .delete:hover {
      background-color: #ba324f;
      color: #fff;
    }
  }
}
.listes {
  position: fixed;
  left: 0;
  top: 0;
  background: #444a;
  width: 100vw;
  height: 100vh;
  ul {
    position: fixed;
    left: 50vw;
    top: 50vh;
    transform: translateY(-50%) translateX(-50%);
    background-color: #fff;
    list-style-type: none;
    li {
      padding: 10px;
    }
    li:hover {
      background-color: #175676;
      cursor: pointer;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/View/VGroupes.vue